$(function() {

	//set variables to determine if scripts for a particular environment need to be called.
	mobileEnvironment = 1;
	tabletEnvironment = 0;
	desktopEnvironment = 0;

	universalController();

	environmentChecker();
	$(window).resize(function(){
		environmentChecker();
	});
});


/**
 * environmentChecker()
 * Checks to see if Mobile, Tablet, or Desktop
 */
function environmentChecker() {
	// console.log('environmentChecker fired');

	if ($(window).width() >= 960) {
		if (tabletEnvironment == 0){
			tabletEnvironment = 1;
			tabletController();
		}; //tabletcheck
		if (desktopEnvironment == 0){
			desktopEnvironment = 1;
			desktopController();
		}; //desktopcheck
		$('body').removeClass('mobile').removeClass('tablet').addClass('desktop');


	} else if ($(window).width() >= 600) {
		if (tabletEnvironment == 0){
			tabletEnvironment = 1;
			tabletController();
		}; //tabletcheck
		$('body').removeClass('mobile').removeClass('desktop').addClass('tablet');

	} else {
		$('body').removeClass('tablet').removeClass('desktop').addClass('mobile');
	}; //window.width

}; //environmentChecker


/**
 * universalController()
 * Run Universal Functions
 */
function universalController() {
	// console.log('universalController Fired');

	$(function() { 
	 	// Validate Email Sign Up
		$('#contact_email').validate();
	});





	// Hide Connect Utility Banner 
	$('.btn-close').click( function (e) {
		$(this).parents('.utility-banner').addClass('is-closed').slideUp();

		if ( $(this).hasClass('set-cookie') && $(this).parents('.utility-banner').is('#connect') ) {
			// If button has class of 'set-cookie' and this fixed banner is a #connect...
			
			// Set Variables
			var connect_id = $(this).parents('.utility-banner').data('connect-id');			
			var connect_expiration = 30;
			// console.log( 'variables: ' + connect_id + ' ' + connect_expiration);
			
			// Set Cookie
			set_connect_cookie(connect_id, connect_expiration);
		}
		e.preventDefault();
	})






	// Check to see if connect_[ID] cookie is set.
	$(function() {    
		if( $.cookie('connect_' + $('#connect').data('connect-id') ) == null ) {
			// If cookie is not set, remove class 'is-closed' from fixed banner.
			$('#connect').removeClass('is-closed').show();
			// console.log('cookie not set');
		} 
		else {
			$('#connect').addClass('is-closed').hide();
			// console.log('cookie set');
		}	
	});






	// Show Connect Utility Banner and Delete Cookie
	$('li.connect > a').click( function (e) {
		$('#connect.utility-banner').removeClass('is-closed').fadeIn();

		if ( $('#connect.utility-banner .btn-close').hasClass('set-cookie') ) {
			// If button has class of 'set-cookie' 
			
			// Set Variables
			var connect_id = $('#connect.utility-banner').data('connect-id');			
			// console.log( 'delete cookie variables: ' + connect_id );
			
			// Delete Cookie
			delete_connect_cookie(connect_id);
		}
		e.preventDefault();
	})






	// Mood Toggle 
	$('.toggle-slider__item').click( function (e) {

		if( $(this).hasClass('is-selected') ) {
			return false;
		} else {

		$(this).siblings().removeClass('is-selected');
		$(this).addClass('is-selected');

			// day (.is-light)
			if ( $(this).hasClass('day') && $(this).hasClass('is-selected')) {
				// If button has class of 'day' 
				// console.log('it is day!');
				$('body').removeClass('is-dark').addClass('is-light');
			} // end day

			// night (.is-dark)
			if ( $(this).hasClass('night')  && $(this).hasClass('is-selected')) {
				// If button has class of 'night' 
				// console.log('**it is night!');
				$('body').removeClass('is-light').addClass('is-dark');
			} // end night
		}
			e.preventDefault();
	})





}; //universalController


/**
 * tabletController()
 * Run Tablet Functions
 */
function tabletController() {
	// console.log('tabletController Fired');

	
}; //tabletController


/**
 * desktopController()
 * Run Desktop Functions
 */
function desktopController() {
	// console.log('desktopController Fired');




// Set background image on product <div>
$('.hero__slide').each( function(index){
	var full_image_url = $(this).data('image-url');
	var product_title = $(this).data('product-title');
	$(this).css('background-image', 'url(' + full_image_url + ')');
	// console.log(index +' image url: ' + full_image_url );
});




// Hide/Show products based on hover
$('.thumbnail').hover( function() {
	var product_title = $(this).find('a').data('product-title') ;
	// console.log(' title: ' + product_title + ' state: hovered ');
	$('.grid__item--hero').hide();
	$('.grid__item--hero.' + product_title ).show();
});



}; //desktopController







// Set cookie for #connect
function delete_connect_cookie (cookie_id) {

	// This function deletes cookie based on cookie ID. 

	// set variables
	var cookie_name = 'connect_' + cookie_id;
	var check_cookie = $.cookie(cookie_name);

	if( check_cookie != null ) {
		$.removeCookie(cookie_name, { path: '/' });
	}
	// console.log('delete cookie ( cookie_name: ' +  cookie_name + ' )');

};//delete_connect_cookie







// Set cookie for #connect
function set_connect_cookie (cookie_id, cookie_expiration) {

	// This function creates a new, unique cookie based on
	// event's ID. The cookies expiration date is set to
	// the date of the event.

	// set variables
	var cookie_name = 'connect_' + cookie_id;
	var check_cookie = $.cookie(cookie_name);
	var cookie_expiration = cookie_expiration;
	
	// check whether the cookie is already set for this visitor
	if( check_cookie == null ) {
		// if the cookie does not exist do the following:	
		// set the cookie so it's there for future visits (including an expiration time in days)
		$.cookie(cookie_name, 'active', { expires: cookie_expiration, path: '/' });
	}
	// console.log('set cookie ( cookie_name: ' +  cookie_name + ' | cookie_duration: ' + cookie_expiration + ' days )');
};//set_connect_cookie